import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private showLoginSubject: BehaviorSubject<boolean>;
  public showLogin: Observable<boolean>;
  constructor() {
    this.showLoginSubject = new BehaviorSubject<boolean>(false);
    this.showLogin = this.showLoginSubject.asObservable();
  }
  setLoginModalValue(state: boolean) {
    this.showLoginSubject.next(state)
  }
  setUserFromSession(from: string){
    sessionStorage.setItem("user_from", from);
  }
  getUserFromSession(){
    return sessionStorage.getItem("user_from")
  }
}
